import { React, useState } from 'react';
import { Button, Collapse, Card, Form } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css'

import './PreferenceBar.scss'

export default function PreferenceBar({hideExpired, setHideExpired, hideRemoved, setHideRemoved}) {
    const [expanded, setExpanded] = useState(false);
    return (
        <div className='preferencebar'>
            <div className='header'>
            <Button onClick={() => setExpanded(!expanded)}
                    aria-controls="bar"
                    aria-expanded={expanded}
                    variant="outline-secondary"
                    size='sm'
                    className='toggle'
            >
                Einstellungen
            </Button>
            </div>
            <Collapse in={expanded} id='bar'>
                <Card>
                    <Card.Body>
                        <Form.Group className='mb-3'>
                            <Form.Group className='mb-3'>
                                <Form.Switch type='checkbox' label='Abgelaufene Prüfröhrchen verstecken' checked={ hideExpired } onChange={() => setHideExpired(!hideExpired)} data-testid='hideExpiredCb'/>
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Switch type='checkbox' label='Entfernte Prüfröhrchen verstecken' checked={ hideRemoved } onChange={() => setHideRemoved(!hideRemoved)} data-testid='hideRemovedCb'/>
                            </Form.Group>
                        </Form.Group>
                    </Card.Body>
                </Card>
            </Collapse>
        </div>
    )
}
